import React from 'react';
import { Skeleton } from 'antd';
import ImageCard from '../ImageCard';
import Wrapper from '../Wrapper';
import './TeacherProfileCard.less';

const TTeacherProfileCardSkeleton: React.FC = () => {
  return (
    <div className="t-skeleton-teacher-profile-card-container">
      <ImageCard cover={<Skeleton.Image className="t-skeleton-cover-image" />}>
        <Wrapper mb={1} display="flex" alignItems="center">
          <Wrapper mr={1}>
            <Skeleton.Avatar size="large" />
          </Wrapper>
          <Skeleton round active paragraph={{ rows: 1 }} />
        </Wrapper>
      </ImageCard>
    </div>
  );
};

export default TTeacherProfileCardSkeleton;
